import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import NewUptimeInfo from 'dashboard/NewUptimeInfo'
import { strings } from 'strings'

export function Server() {
  const classes = useStyles()

  return (
    <Paper className={classes.paper}>
      <Typography className={classes.title}>
        {strings.linksStabilityStatus}
      </Typography>
      <NewUptimeInfo />
    </Paper>
  )
}

const useStyles = makeStyles((theme) => ({
  paper: {
    // flip: false,
    position: 'relative',
    width: `calc(100dvw - ${theme.spacing(2)}px)`,
    height: `calc(100dvh - 48px - ${theme.spacing(3)}px)`,
    padding: theme.spacing(1),
    backgroundColor: '#fff',
    overflowY: 'scroll',
    direction: 'ltr',
  },
  title: {
    borderRadius: '4px 4px 0 0',
    background: 'silver',
    fontWeight: 600,
    padding: '0.25rem 0.5rem',
    marginBottom: '0.5rem',
    margin: -8,
  },
}))
